import {useLocation, useNavigate, useParams} from "react-router";
import {useCampaign} from "@/campaigns/CampaignContextHooks.ts";
import DetailPaneState from "@/components/management/DetailPaneState.tsx";
import {useModal} from "@/modal/ModalHooks.ts";
import CharacterDetail from "@/characters/CharacterDetail.tsx";
import {useCharacterQuery} from "@/characters/CharacterQueries.ts";

export default function CharacterDetailRoute() {
    const {id} = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const {campaignPath} = useCampaign();
    const {showCharacter} = useModal();
    const query = useCharacterQuery(id);

    if (query.isPending) return <DetailPaneState title="Charakter wird geladen…" loading/>;
    if (query.isError) return <DetailPaneState title="Charakter konnte nicht geladen werden" onRetry={() => void query.refetch()}/>;
    if (!query.data) return <DetailPaneState title="Charakter nicht verfügbar"/>;

    const character = query.data;
    const edit = () => navigate({pathname: campaignPath(`characters/${character.id}/edit`), search: location.search});
    const onDeleted = () => navigate(
        {pathname: campaignPath("characters"), search: location.search},
        {replace: true},
    );

    return <CharacterDetail key={character.id}
                            character={character}
                            onDisplay={() => showCharacter(character.id)}
                            onEdit={edit}
                            onDeleted={onDeleted}/>;
}
